import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let id = useDataValue({
    context: 'dental_monitoring',
    path: 'id',
    viewPath: props.viewPath,
  })

  return {
    variables: { id },
  }
}
